(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('data_protection_policy', {
            parent: 'account',
            url: '/data_protection_policy',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.data_protection_policy'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/data_protection_policy/data_protection_policy.html',
                    controller: 'DataProtectionPolicyController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dataProtectionPolicy');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
